import { useMemo } from "react";

import { useDialerDirectCall } from "@/hooks/dialer/use-dialer-direct-call";
import { CallButton as MiniDialerCallButton } from "@/modules/calling/control-menu/v2/buttons/call-button";
import { useDialerCallStatus } from "@/hooks/dialer/use-dialer-call-status";
import { DIALER_CALL_STATUS } from "@/constants/dialer";
import { useInCallContext } from "@/hooks/dialer/use-dialer-context";
import { withDoubleClickDisabled } from "@/helpers/utils";

/**
 * GLE-8464: the contact card has no "Start call" button before a call, for
 * every user. The Trellus button starts calls. The phone numbers in the card
 * still start a GC call, and a GC call keeps its end and "Call Again" buttons.
 */
export const CallButton = () => {
  const status = useDialerCallStatus();

  const { startDirectCall } = useDialerDirectCall();
  const { contact: callingContact } = useInCallContext();

  const callAgain = useMemo(
    () =>
      withDoubleClickDisabled(() => {
        if (callingContact) {
          return startDirectCall({
            contact: {
              id: callingContact.id as string,
              phone: callingContact.phone,
            },
          });
        }
      }),
    [startDirectCall, callingContact]
  );

  return (
    <>
      {DIALER_CALL_STATUS.DURING === status && <MiniDialerCallButton />}

      {DIALER_CALL_STATUS.AFTER === status && (
        <MiniDialerCallButton onStartCall={callAgain} />
      )}
    </>
  );
};
